import React, { useState, useEffect, useMemo } from 'react';
import {
    Widget,
    GridView,
    Table,
    ColumnProps,
    CrudMasterDetailView,
    CompositeView,
    CrudContext,
    MasterDetailForm,
    Row,
    Col,
    Form,
    FormInput,
    Button,
    FormResetButton,
    notification
} from '@digital/ui';
import { PaginationConfig } from 'antd/lib/pagination';
import { Switch, Icon, Collapse } from 'antd';

import { compareBool, compareText, compareTypeNumber } from '@app/helpers/comparators';

import { hasPermission } from '@app/helpers/permissions';

import { CrfCicloOrcamentario, getAllCrfCicloOrcamentario } from '@app/api/crf/crfcicloorcamentario';
import {
    CrfProjetoDefinicao,
    getAllCrfProjetoDefinicao,
    updateConcluirCrfCicloOrcamentario,
    updateCrfCicloOrcamentarioProjeto,
} from '@app/api/crf/crfDefinicaoProjeto';

const CrfDefinicaoProjeto = () => {

    const { Panel } = Collapse;
    const [allProjetoDefinicao, setProjetoDefinicao] = useState<CrfProjetoDefinicao[]>();
    const [itenSelecionado, setItenSelecionado] = useState();
    const [ciclos, setCiclos] = useState(() => getAllCrfCicloOrcamentario);


    const colluns: ColumnProps<CrfProjetoDefinicao>[] = [
        {
            title: 'N',
            dataIndex: 'index',
            width: '3%',
            sorter: (a, b) => compareTypeNumber(a.index, b.index),
        },
        {
            title: 'Código',
            dataIndex: 'codigo',
            sorter: (a, b) => compareText(a.codigo, b.codigo),
            width: '3%',
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar"
                            name="codigo"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.codigo !== undefined &&
                record.codigo !== null &&
                record.codigo
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'Número',
            dataIndex: 'numero',
            sorter: (a, b) => compareText(a.numero, b.numero),
            width: '3%',
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar"
                            name="numero"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.numero !== undefined &&
                record.numero
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'NOME',
            dataIndex: 'nome',
            sorter: (a, b) => compareText(a.nome, b.nome),
            width: '20%',
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar"
                            name="nome"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.nome !== undefined &&
                record.nome
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'STATUS',
            dataIndex: 'statusProjetoNome',
            sorter: (a, b) => compareText(a.statusProjetoNome, b.statusProjetoNome),
            width: '10%',
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar"
                            name="statusProjetoNome"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.statusProjetoNome !== undefined &&
                record.statusProjetoNome
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'DATA DE CONCLUSÃO',
            dataIndex: 'dataConclusao',
            sorter: (a, b) => compareText(a.dataConclusao, b.dataConclusao),
            width: '10%'
        },
        {
            title: 'PREVISÃO',
            dataIndex: 'previsao',
            sorter: (a, b) => compareText(a.previsao, b.previsao),
            width: '10%',
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar"
                            name="previsao"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.previsao !== undefined &&
                record.previsao
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'FORECAST ANO',
            dataIndex: 'forecastAno',
            width: '5%',
            sorter: (a, b) => compareBool(a.forecastAno, b.forecastAno),
            render: (index, record) => {
                return <>
                    <Switch
                        checked={record.forecastAno}
                        disabled={record.previsaoCodigo === 1}
                        onChange={() => {
                            if (allProjetoDefinicao) {
                                let itemAlterado = {} as CrfProjetoDefinicao;
                                const result = allProjetoDefinicao.filter((projeto) => {
                                    if (projeto.id === record.id) {
                                        const novoValor = !projeto.forecastAno;

                                        projeto.forecastAno = novoValor;
                                        projeto.vrp = !novoValor;

                                        itemAlterado = projeto;
                                        return projeto;
                                    } else {
                                        return projeto;
                                    }
                                });

                                harUpdateCicloOrcamentarioProjeto(itemAlterado);
                                setProjetoDefinicao(result);
                            }
                        }} />
                </>
            },
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar"
                            name="forecastAno"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.forecastAno !== undefined &&
                record.forecastAno
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'Não Previstos',
            dataIndex: 'contagemNaoPrevisto',
            width: '5%',
            sorter: (a, b) => compareBool(a.contagemNaoPrevisto, b.contagemNaoPrevisto),
            render: (index, record) => {
                return <>
                    <Switch
                        checked={record.contagemNaoPrevisto}
                        disabled={record.previsaoCodigo === 1}
                        onChange={() => {

                            if (allProjetoDefinicao) {
                                if (record.vrp === true) {
                                    notification.error('O projeto não pode ser VRP e NÃO PREVISTO ao mesmo tempo.');
                                    return;
                                }

                                let itemAlterado = {} as CrfProjetoDefinicao;
                                const result = allProjetoDefinicao.filter((projeto) => {
                                    if (projeto.id === record.id) {
                                        const novoValor = !projeto.contagemNaoPrevisto;

                                        projeto.contagemNaoPrevisto = novoValor;
                                        itemAlterado = projeto;
                                        return projeto;
                                    } else {
                                        return projeto;
                                    }
                                });
                                harUpdateCicloOrcamentarioProjeto(itemAlterado);
                                setProjetoDefinicao(result);
                            }
                        }} />
                </>
            },
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar"
                            name="contagemNaoPrevisto"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.contagemNaoPrevisto !== undefined &&
                record.contagemNaoPrevisto
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),

        },
        {
            title: 'VRP',
            dataIndex: 'vrp',
            width: '5%',
            sorter: (a, b) => compareBool(a.vrp, b.vrp),
            render: (index, record) => {
                return <>
                    <Switch
                        checked={record.vrp}
                        disabled={record.previsaoCodigo === 1}
                        onChange={() => {
                            if (allProjetoDefinicao) {
                                let itemAlterado = {} as CrfProjetoDefinicao;
                                const result = allProjetoDefinicao.filter((projeto) => {
                                    if (projeto.id === record.id) {
                                        const novoValor = !projeto.vrp;

                                        projeto.vrp = novoValor;
                                        projeto.forecastAno = !novoValor;
                                        projeto.contagemNaoPrevisto = false;

                                        itemAlterado = projeto;
                                        return projeto;
                                    } else {
                                        return projeto;
                                    }
                                });
                                harUpdateCicloOrcamentarioProjeto(itemAlterado);
                                setProjetoDefinicao(result);
                            }
                        }} />
                </>
            },
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar"
                            name="vrp"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.vrp !== undefined &&
                record.vrp
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'RPP',
            dataIndex: 'rpp',
            width: '5%',
            sorter: (a, b) => compareBool(a.rpp, b.rpp),
            render: (index, record) => {
                return <>
                    <Switch
                        checked={record.rpp}
                        onChange={() => {
                            if (allProjetoDefinicao) {
                                let itemAlterado = {} as CrfProjetoDefinicao;
                                const result = allProjetoDefinicao.filter((projeto) => {
                                    if (projeto.id === record.id) {

                                        const novoValor = !projeto.rpp;
                                        projeto.rpp = novoValor;
                                        itemAlterado = projeto;
                                        return projeto;
                                    } else {
                                        return projeto;
                                    }
                                });
                                harUpdateCicloOrcamentarioProjeto(itemAlterado);
                                setProjetoDefinicao(result);
                            }
                        }} />
                </>
            },
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar"
                            name="rpp"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.rpp !== undefined &&
                record.rpp
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
    ]

    const codiguracaoPaginacao = {
        pageSize: 10,
        onChange: (() => {
            let element = document.getElementById("tableResultDefinicaoProjeto");
            if (element) {
                element.scrollIntoView();
            }
        })
    } as PaginationConfig;




    const harUpdateCicloOrcamentarioProjeto = (valores: CrfProjetoDefinicao) => {
        updateCrfCicloOrcamentarioProjeto(valores);
    }

    useEffect(() => {
        setCiclos(() => Promise.resolve(undefined));
        setCiclos(() => getAllCrfCicloOrcamentario);
    })

    useEffect(() => {
        if (itenSelecionado) {
            const cicloAno = itenSelecionado as CrfCicloOrcamentario;
            getAllCrfProjetoDefinicao(cicloAno.ano).then((data) => {
                setProjetoDefinicao(data);
            });
        }

    }, [itenSelecionado]);


    const btn = useMemo(() => {
        return [
            <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                    if (itenSelecionado) {
                        const cicloAno = itenSelecionado as CrfCicloOrcamentario;
                        updateConcluirCrfCicloOrcamentario(cicloAno.id);
                    }
                }}
                confirm={"Deja realizar a operação"}
                size="small">
                Concluir Ciclo Ano
            </Button>
        ]
    }, [itenSelecionado])




    return (
        <CrudMasterDetailView
            getAllItems={ciclos}
            disableNotification
            icon="business-process"
            detailTitleExtractor={item => `${item.ano}`}
            filterPredicate={(item, value) =>
                (item.descricao && item.descricao.toLowerCase().includes(value.toLowerCase())) ||
                (item.ano !== undefined &&
                    item.ano
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase()))
            }
            titleExtractor={item => `${item.ano}`}
            descriptionExtractor={item => ''}>
            <CompositeView>
                {hasPermission(['Dono', 'MODULO_CADASTRO_BASICO_VISUALIZAR_MENU']) && (
                    <CrudContext.Consumer>
                        {({ selectedItem }) => {
                            setItenSelecionado(selectedItem);
                            return (
                                <GridView noform>
                                    <Collapse bordered={false} defaultActiveKey={['1']} expandIcon={() => <Icon type="arrows-right_4" />}>
                                        <Panel key="1" header="DEFINIÇÃO DOS PROJETOS CICLO ANO" style={{ border: 0 }}>
                                            <MasterDetailForm>
                                                <Widget
                                                    actions={btn}>
                                                    <Row>
                                                        <Row>
                                                            <Col span={12}>
                                                                <Table
                                                                    rowKey="id"
                                                                    key="id"
                                                                    columns={colluns}
                                                                    dataSource={allProjetoDefinicao}
                                                                    pagination={codiguracaoPaginacao}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </Row>
                                                </Widget>
                                            </MasterDetailForm>
                                        </Panel>
                                    </Collapse>

                                </GridView>


                            );
                        }}
                    </CrudContext.Consumer>
                )}
            </CompositeView>
        </CrudMasterDetailView>
    );
}
export default CrfDefinicaoProjeto;